/**
 * `<back-to-top>` custom element (feature list v1.2).
 *
 * Appears after one and a half viewports of scroll and takes the customer
 * back to the top. Smooth scrolling only when the user has no
 * reduced-motion preference.
 */
class BackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      const smooth = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    });

    const onScroll = () => {
      this.hidden = window.scrollY < window.innerHeight * 1.5;
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
